import React from "react"

export const CommentFillIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M5.59995 2.16016C6.06504 2.16018 6.52535 2.25385 6.95347 2.43555C7.5809 2.7043 8.1165 3.15072 8.49351 3.71973C8.87042 4.28859 9.07256 4.95531 9.07554 5.6377C9.07281 6.55954 8.70634 7.44332 8.05601 8.09668C7.73861 8.41178 7.3645 8.66452 6.95347 8.84082C6.12643 9.18708 5.19797 9.20293 4.35972 8.88477L2.06284 9.58398C2.03212 9.59712 1.9993 9.60607 1.96616 9.61035C1.91335 9.61124 1.86106 9.5998 1.81382 9.57617C1.76659 9.55249 1.72561 9.51745 1.69468 9.47461C1.66374 9.43164 1.64359 9.38151 1.63609 9.3291C1.62859 9.27666 1.63404 9.2228 1.65171 9.17285L2.35093 6.87598C2.19868 6.48118 2.12138 6.06083 2.12339 5.6377C2.12276 5.17235 2.21529 4.71153 2.39487 4.28223C2.57117 3.87119 2.82392 3.49709 3.13902 3.17969C3.45565 2.86169 3.8314 2.60856 4.24546 2.43555C4.67374 2.25373 5.13468 2.16016 5.59995 2.16016Z"
        fill="white"
      />
    </svg>
  )
}
